<template>
<footer class="main-footer">
  <span>Copyright © {{$t('selectPage.wyd_global_development_center')}}</span>
</footer>
</template>

<script>
export default {
  name: 'MainFooter'
}

</script>

<style scoped lang="scss">
.main-footer{
  text-align: center;
  color: #ffffff;
  height: 58px;
  font-size: 12px;
  opacity: 0.7;
  span {
    user-select: none;
  }
}
</style>
